module.exports = __webpack_public_path__ + "/70871f7a0d91246a240238910a4f3074.svg";